"use strict";

var mapValues = require('lodash.mapvalues');
var isEmpty = require('lodash.isempty');
var rules = require('./common-rules');

/**
 * get the value stored in the object following the dot notation
 * ie. getValue('a.b', {a: {b: 1}}) === 1
 *
 * @param  {String} key     location of the value using dot notation
 * @param  {Object} data   object to look
 * @return {Object}         content of data in the key position
 */
function getValue(key, data) {
  var keys = key.split('.');
  Object.keys(keys).forEach(function (k) {
    // eslint-disable-next-line
    data = data && data[keys[k]];
  });
  return data;
}

/**
 * Helper function that executes a set of validations on a specific value
 * @param  {Object || String} value          the value to test
 * @param  {String} key                      name of the field to validate
 * @param  {Object || Function} validations  schema to validate
 * @param  {Object} attributes               whole data object
 * @return {Object}                          Errors or empty object
 */
function executeValidations(value, key, validations, attributes) {
  var result = {};
  var error;
  if (typeof validations === 'function') {
    result = validations(value, key, attributes);
  } else {
    Object.keys(validations).forEach(function (index) {
      error = validations[index](value, key, attributes);
      if (error !== undefined) {
        result[index] = error;
      }
    });
  }
  return result;
}

/**
 * validate the data based on the provided schema
 * @param  {Object} data
 * @param  {Object} schema each entry has to be a validator function
 * @return {Object} errors or ok
 */
function validate(data, schema) {
  var result = {};
  var error;
  Object.keys(schema).forEach(function (key) {
    error = executeValidations(getValue(key, data), key, schema[key], data);
    if (!isEmpty(error)) {
      result[key] = error;
    }
  });
  return result;
}

/**
 * Util function to write parametrized validations
 * @param  {Function} f  function that receives options, value, key, attributes
 * @return {Function}    returns a function that takes options and return a parametrized validation
 */
function createValidator(f) {
  return function (options) {
    return function (value, key, attributes) {
      return f(options, value, key, attributes);
    };
  };
}
module.exports = {
  validate: validate,
  validators: mapValues(rules, createValidator),
  createValidator: createValidator
};
